import { Navigate, redirect } from 'react-router-dom';

import { TemplateType } from '@e-origin/shared';

import { ManageTSDs } from '@admin/components/ManageTSDs';
import { RouteErrorBoundary } from '@components';
import { AdminLogin } from './components/auth/AdminLogin';
import { AdminProtectedRoute } from './components/auth/AdminProtectedRoute';
import { CustomsSystems } from './components/CustomsSystems';
import { AdminUserLayout } from './components/layout/UserLayout';
import { ManageBatches } from './components/ManageBatches';
import { ManageCatalogs } from './components/ManageCatalogs';
import { ManageCharts } from './components/ManageCharts';
import { ManageCustomsErrors } from './components/ManageCustomsErrors';
import { EditDeclarant, ManageDeclarants } from './components/ManageDeclarants';
import { EditTemplate, ManageTemplates } from './components/ManageTemplates';
import { ManageTransactionTypes } from './components/ManageTransactionTypes';
import { ManageTransits } from './components/ManageTransits';
import { ManageUsers } from './components/ManageUsers';
import { RequestLogger } from './components/RequestLogger';

const editTemplateLoader = ({ params }) => {
  const { type, id } = params;

  if (!Object.values(TemplateType).includes(type)) {
    return redirect('/admin/manage-templates');
  }

  if (id && !/^[a-f\d]{24}$/i.test(id)) {
    return redirect('/admin/manage-templates');
  }

  return null;
};

export const AdminRoutes = [
  {
    path: '/admin',
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '',
        element: (
          <AdminProtectedRoute>
            <AdminUserLayout />
          </AdminProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="manage-users" replace /> },
          { path: 'manage-users', element: <ManageUsers /> },
          { path: 'manage-declarants', element: <ManageDeclarants /> },
          { path: 'manage-declarants/:id', element: <EditDeclarant /> },
          { path: 'manage-transaction-types', element: <ManageTransactionTypes /> },
          { path: 'manage-templates', element: <ManageTemplates /> },
          { path: 'manage-templates/edit/:type', loader: editTemplateLoader, element: <EditTemplate /> },
          { path: 'manage-templates/edit/:type/:id', loader: editTemplateLoader, element: <EditTemplate /> },
          { path: 'manage-charts', element: <ManageCharts /> },
          { path: 'customs-systems', element: <CustomsSystems /> },
          { path: 'manage-batches', element: <ManageBatches /> },
          { path: 'manage-transits', element: <ManageTransits /> },
          { path: 'manage-tsds', element: <ManageTSDs /> },
          { path: 'manage-customs-errors', element: <ManageCustomsErrors /> },
          { path: 'manage-catalogs', element: <ManageCatalogs /> },
          { path: 'request-observability', element: <RequestLogger /> },
        ],
      },
      { path: 'auth', element: <AdminLogin /> },
      { path: '*', element: <Navigate to="/admin" replace /> },
    ],
  },
];
